import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { withRouter } from 'react-router-dom';

import { useActiveForm } from '@/components/form/ActiveSwitch';
import FormWrapper from '@/components/form/Wrapper';
import { useAppAlert } from '@Components/AppAlert';
import FormStatusProvider from '@Components/form/StatusWrapper';
import { useStatusForm } from '@Components/form/context';
import history from 'utils/history';

import Form from '../components/Form';
import Heading from '../components/Heading';
import { PathProvider, usePathStore } from '../store';

const PathForm = withRouter(({ match: { params: { id } } }) => {
  const { collection: { item, useLoad, useSubmit, reset } } = usePathStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { active, setActive } = useActiveForm(item)

  const { handleStatus } = useStatusForm()
  const loadData = useLoad(id)
  const handleSubmit = useSubmit()

  const handleSubmitAndOpen = async payload => {
    try {
      const { id } = await handleSubmit({ ...payload, active })
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Path ${message}.`)
      handleStatus({ hasChange: false })
      if (id) {
        reset()
        history.push(`./${id}`)
      } else {
        reset()
        await loadData()
      }
    } catch {
      handleError('Error', 'Path was not saved.')
    }
  }

  if (!item) {
    return null
  }

  return <FormWrapper title='Path'>
    <Heading data={item} active={active} onChangeActive={setActive} />
    <Form data={item} handleSubmit={handleSubmitAndOpen} />
  </FormWrapper>
});

export default function PathFormLayout() {
  return <PathProvider>
    <DndProvider backend={HTML5Backend}>
      <FormStatusProvider>
        <PathForm />
      </FormStatusProvider>
    </DndProvider>
  </PathProvider>
}
